// extracted by mini-css-extract-plugin
export default {"Wrapper":"EditBadge_Wrapper__nkxZc"};